<template>
  <div class="enrollInputTextWrapper">
    <input type="text" placeholder="제목을 기입해주세요." maxlength="22"
           v-model="text" v-on:keyup="returnTextLength" v-on:blur="onChangeText">
    <span>{{textLength + '/' + maxLength}}</span>
  </div>
</template>

<script>

export default {
  data () {
    return {
      text: '',
      textLength: 0,
      maxLength: 22
    }
  },
  methods: {
    returnTextLength: function (e) {
      this.setTextLength(e.target.value.length)
    },
    setTextLength: function (length) {
      this.textLength = length > 22 ? 22 : length
    },
    onChangeText: function () {
      this.textLength = this.text.length
      this.setTextInfoStore(this.text)
    },
    setTextInfoStore: function (text) {
      this.$store.commit('setEnrollStateValue', {type: 'titleText', value: text !== '' ? text : null})
      this.$store.commit('setAdUiStateValue', {type: 'titleText', value: text !== '' ? text : null})
    }
  },
  created: function () {
    let beforeText = this.$store.getters.getEnrollStateValue('titleText')
    if(beforeText != null) {
      this.text = beforeText
      this.setTextLength(beforeText.length)
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
input[type='text']{
  padding: 0 0 10px;
  width: 100%;
  font-size: 13px;
  border-top: none;
  border-left: none;
  border-right: none;
  border-bottom: 2px rgb(112,112,112) solid;
  outline: none;
}

.enrollInputTextWrapper{
  text-align: right;
  flex: 1;
}

.enrollInputTextWrapper > span{
  font-size: 10px;
}
</style>



// WEBPACK FOOTER //
// src/components/board/elements/enrollInputTextTitle.vue